export enum TermIdEnum {
    ENTRY_NO = 8230,
    CROSS = 8377,
    TRIAL_INSTANCE = 8170,
    EXPT_DESIGN = 8135,
    LOCATION_ID = 8190,
    GID = 8240
}
